export default "__VITE_ASSET__DizzRrxe__"